import { render, staticRenderFns } from "./callout.vue?vue&type=template&id=7ebf0c04&scoped=true&"
import script from "./callout.vue?vue&type=script&lang=js&"
export * from "./callout.vue?vue&type=script&lang=js&"
import style0 from "./callout.vue?vue&type=style&index=0&id=7ebf0c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf0c04",
  null
  
)

export default component.exports